import axios from 'axios';

import { decodeError } from '@genially/ui/build/utils/decodeError';

import { config } from '../../bootstrap/application/config/config';
import { getToken } from './tokenStore';

const client = axios.create({
  baseURL: `${config.urls.api}/api`,
  withCredentials: true,
});

export const CoreApiService = {
  getFeatureFlags: (teamId: string): Promise<string[]> => {
    const bearer = getToken();

    return client
      .get<string[]>('/v1/users/@me/feature-flags', {
        params: { teamId },
        headers: {
          ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}),
        },
      })
      .then(res => res.data)
      .catch(error => {
        console.error(decodeError(error));

        return [];
      });
  },
};
